export const capitalize = (value:string) => {
	return value.replace(value.charAt(0), value.charAt(0).toUpperCase())
}
